import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 300px;
  .ant-select {
    width: 100%;
  }
`;
